import React from 'react';

const SkipConfirmationModal = ({
  isOpen,
  onCancel,
  onConfirm,
  content
}) => {
  if (!isOpen) return null;

  // Default content
  const defaultContent = {
    title: 'Incomplete Section',
    message: 'You haven\'t completed this section. Would you like to:',
    cancelText: 'Go Back and Complete',
    confirmText: 'Skip for Now'
  };

  // Use custom content if provided, else use defaults
  const title = content?.title || defaultContent.title;
  const message = content?.message || defaultContent.message;
  const cancelText = content?.cancelText ?? defaultContent.cancelText;
  const confirmText = content?.confirmText ?? defaultContent.confirmText;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div>
          <h3>{title}</h3>
          <p>{message}</p>
          <div className="buttonContainer mt-2">
            {cancelText && (
              <button className="buttonSecondary" onClick={onCancel}>
                <span className="button-text">{cancelText}</span>
              </button>
            )}
            {confirmText && (
              <button className="button" onClick={onConfirm}>
                {confirmText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkipConfirmationModal;


// import React from 'react';

// const SkipConfirmationModal = ({ 
//   isOpen, 
//   onCancel, 
//   onConfirm, 
//   content 
// }) => {
//   if (!isOpen) return null;

//   // Default content
//   const defaultContent = {
//     title: 'Incomplete Section',
//     message: 'You haven\'t completed this section. Would you like to:',
//     cancelText: 'Go Back and Complete',
//     confirmText: 'Skip for Now'
//   };

//   // Use custom content if provided, else use defaults
//   const title = content?.title || defaultContent.title;
//   const message = content?.message || defaultContent.message;
//   const cancelText = content?.cancelText || defaultContent.cancelText;
//   const confirmText = content?.confirmText || defaultContent.confirmText;

//   return (
//     <div className="modal-overlay">
//       <div className="modal-content">
//         <div>
//           <h3>{title}</h3>
//           <p>{message}</p>
//           <div className="buttonContainer mt-2">
//             <button className="buttonSecondary" onClick={onCancel}>
//               <span className="button-text">{cancelText}</span>
//             </button>
//             <button className="button" onClick={onConfirm}>
//               {confirmText}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SkipConfirmationModal;
